/**
 * geo-instant-switch.js — AussieAura
 * Instantly updates geo-aware text when visitor switches country/currency.
 * Syncs from Shopify.currency.active on page load so announcement bar
 * ALWAYS matches the currency shown in the header selector.
 */
(function () {
  var GEO = {
    AU: {
      announcement_shipping:  '🇦🇺 <strong>Australian Owned &amp; Operated</strong> | Free Shipping Across Australia',
      announcement_customers: '<strong>4.9 ⭐ Rating</strong> · 7,148+ Happy Customers',
      product_shipping:       '<p>🚚 <strong>Fast, Free Delivery — Australia-Wide</strong><br>Processed within 1–2 business days. Estimated delivery: <strong>3–14 business days</strong> across Australia. Tracking included.</p>',
      trust_bar_location:     'Based in Australia 🇦🇺'
    },
    NZ: {
      announcement_shipping:  '🇦🇺 <strong>Australian Owned &amp; Operated</strong> | Free Shipping to New Zealand',
      announcement_customers: '<strong>4.9 ⭐ Rating</strong> · 7,148+ Happy Customers',
      product_shipping:       '<p>🚚 <strong>Free, Tracked Delivery to New Zealand</strong><br>Processed within 1–2 business days. Estimated delivery: <strong>7–10 business days</strong>. Delivery times are estimates and may be affected by carriers or customs.</p>',
      trust_bar_location:     'Based in Australia 🇦🇺'
    }
  };

  var CURRENCY_MAP = { 'AUD': 'AU', 'NZD': 'NZ' };

  function updateAll(code) {
    var content = GEO[code] || GEO.AU;
    document.querySelectorAll('[data-geo]').forEach(function (el) {
      var key = el.getAttribute('data-geo');
      if (content[key] !== undefined) {
        el.style.opacity = '0';
        el.style.transition = 'opacity 0.15s ease';
        el.innerHTML = content[key];
        requestAnimationFrame(function () { el.style.opacity = '1'; });
      }
    });
    try { sessionStorage.setItem('aa_geo', code); } catch(e) {}
  }

  function getActiveCountry() {
    // Primary: Shopify's own currency variable — always matches header selector
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (currency) return CURRENCY_MAP[currency] || 'AU';
    // Fallback: sessionStorage
    try {
      var stored = sessionStorage.getItem('aa_geo');
      if (stored && GEO[stored]) return stored;
    } catch(e) {}
    return null;
  }

  function init() {
    // Intercept currency/country switcher clicks
    document.addEventListener('click', function (e) {
      var item = e.target.closest('[data-value]');
      if (!item || !item.closest('localization-form-component')) return;
      var code = item.getAttribute('data-value');
      updateAll(GEO[code] ? code : 'AU');
    });

    // Also catch on:click="/selectCountry/XX" pattern
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[on\\:click]');
      if (!el) return;
      var m = (el.getAttribute('on:click') || '').match(/selectCountry\/([A-Z]{2})/);
      if (m) updateAll(GEO[m[1]] ? m[1] : 'AU');
    });

    // On page load: sync with ACTUAL active Shopify currency
    var active = getActiveCountry();
    if (active) requestAnimationFrame(function () { updateAll(active); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();